import React from "react"
import { Link } from "react-router-dom"
import enq from "../../Assets/site1.jpg"
import enqTwo from "../../Assets/hero1.jpg"

const About = () => {
	return (
		<div className="about-section">
			<div className="container-main">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<h1 className="about-heading montserrat">Le Fille <span className="about-block-text montserrat">Global School</span></h1>

						<div className="about-feature-badges">
							<div className="about-badge-card">
								<div className="about-badge-icon" style={{ background: "linear-gradient(135deg,#8B6820,#C4935A)" }}>
									<i className="ri-medal-line"></i>
								</div>
								<div className="about-badge-text">
									<h6>Academic Excellence</h6>
									<p>Board-focused science &amp; commerce streams with strong outcomes.</p>
								</div>
							</div>
							<div className="about-badge-card">
								<div className="about-badge-icon" style={{ background: "linear-gradient(135deg,#C4935A,#e0a96d)" }}>
									<i className="ri-book-open-line"></i>
								</div>
								<div className="about-badge-text">
									<h6>Entrance Coaching</h6>
									<p>Integrated NEET, JEE, KEAM &amp; CUET preparation.</p>
								</div>
							</div>
							<div className="about-badge-card">
								<div className="about-badge-icon" style={{ background: "linear-gradient(135deg,#174e4a,#2e8a83)" }}>
									<i className="ri-global-line"></i>
								</div>
								<div className="about-badge-text">
									<h6>Global Pathways</h6>
									<p>International university counseling &amp; scholarship guidance.</p>
								</div>
							</div>
						</div>

						<Link className="btn enquire-btn-about" to="/about">About Us</Link>
					</div>

					<div className="col-lg-6">
						<div className="about-stack-imgs">
							<div className="about-stack-top">
								<img src={enq} alt="Le Fille students" />
							</div>
							<div className="about-stack-bottom">
								<img src={enqTwo} alt="Le Fille campus" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default About
